module.exports = __webpack_public_path__ + "img/ars.bdfb0b00.png";